import React from 'react';
import ReportLauncherCard from '../../../Elements/ReportLauncher/ReportLauncherCard';

function ReportLauncherDemoComponent() {
  return (
    <div style={{ maxWidth: 700 }}>
      <div className='rp-sec-head'>
        <h2>Demo Section</h2>
        <span className='rp-tally'>2</span>
        <span className='rp-hr' />
      </div>
      <div className='rp-grid'>
        <ReportLauncherCard
          title='Demo Excel Export'
          description='Export an Excel workbook of demo data.'
          fmt='XLSX'
          iconName='fa-solid fa-file-lines'
          note='Generated file downloadable for 3 days'
          onClick={() => {}}
        />
        <ReportLauncherCard
          title='Demo KPI Report'
          description='Run a report to view demo KPIs (violet report-kind accent).'
          fmt='REPORT'
          kind='report'
          iconName='fa-solid fa-chart-line'
          onClick={() => {}}
        />
      </div>
    </div>
  );
}

export const reportLauncherDemo = {
  id: 'report-launcher',
  title: 'Report launcher (sections + cards)',
  category: 'Cards',
  importPath: 'src/Elements/ReportLauncher/ (ReportLauncherPage, ReportLauncherCard)',
  notes: [
    'ReportLauncherPage renders the full page: permission-filtered sections, live search, count readout fixed into the 80px header band (mirrors .blist-actions), DS empty state, and an `overlay` slot for the caller-owned modals.',
    'Cards whose roleKey fails RoleService.CheckUserPermission are hidden entirely — tallies and the header count reflect visible cards only. Role context defaults to ButtonRowButton (pass roleContext for link-gated pages).',
    "kind: 'report' switches the card to the violet report accent and a 'Run report' button; the optional gold `note` row is for delivery caveats.",
    'First consumer: Reports ▸ OPS Reports (ReportAdmin.js). The finance report index pages are planned follow-ups.',
  ],
  snippet:
    "<ReportLauncherPage\n  sections={[{ title: 'Finance & Accounting', cards: [{ title, description, fmt: 'XLSX', iconName, roleKey, onClick }] }]}\n  overlay={this.renderPanels()}\n/>",
  render: ReportLauncherDemoComponent,
};
